/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

module.exports = global["jQuery"] = require("-!/var/lib/jenkins/workspace/web-react_release_5.12/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[8].oneOf[3]!/var/lib/jenkins/workspace/web-react_release_5.12/node_modules/source-map-loader/dist/cjs.js!./jquery.min.js");
